export default {
    xsmall: 575,
    small: 767,
    medium: 991,
    large: 1199
}



// WEBPACK FOOTER //
// ./src/util/css/media.js